
const GAIA_HOME = "https://gaia.nullschool.net";

/**
 * @param {string} parts
 * @returns {string}
 */
export function gaiaPath(...parts) {
    return [GAIA_HOME, ...parts].join("/");
}
